import { render, staticRenderFns } from "./FormElements.vue?vue&type=template&id=dd0f8220"
import script from "./FormElements.vue?vue&type=script&lang=js"
export * from "./FormElements.vue?vue&type=script&lang=js"
import style0 from "./FormElements.vue?vue&type=style&index=0&id=dd0f8220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports